function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 8.875,
  y: 5.4375,
  width: 13.8125,
  height: 14.625,
  rx: 2,
  stroke: "#48A1F8",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5625 11.125L21.875 11.125",
  stroke: "#48A1F8",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.82008 5.26588L14.0076 4.07497C14.7616 3.96529 15.4375 4.54999 15.4375 5.31196V20.188C15.4375 20.95 14.7616 21.5347 14.0076 21.425L5.82007 20.2341C5.20568 20.1448 4.75 19.618 4.75 18.9971V6.50286C4.75 5.88201 5.20568 5.35525 5.82008 5.26588Z",
  fill: "white",
  stroke: "#48A1F8",
  strokeWidth: 1.5
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.42383 11.5581L8.42383 11.125C8.42383 10.2275 9.15137 9.5 10.0488 9.5V9.5C10.9463 9.5 11.6738 10.2275 11.6738 11.125L11.6738 11.9912C11.6738 12.8887 10.9463 13.6162 10.0488 13.6162V13.6162",
  stroke: "#48A1F8",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0488 12.2434V12.2434C9.15137 12.2434 8.42383 12.971 8.42383 13.8684L8.42383 14.7347C8.42383 15.6321 9.15137 16.3597 10.0488 16.3597V16.3597C10.9463 16.3597 11.6738 15.6321 11.6738 14.7347L11.6738 14.3016",
  stroke: "#48A1F8",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 20.25,
  cy: 7.875,
  r: 0.8125,
  fill: "#2E89E1"
});

var SvgHtml = function SvgHtml(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHtml, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/html.ab771cd6.svg";
export { ForwardRef as ReactComponent };